/* src/app/modules_v2/booking/locations/components/sections/location-service-section/location-service-section.component.css */
.service-section {
  padding: 20px;
}
.section-header h6.fw-bold {
  color: #333;
  font-size: 18px;
  margin-bottom: 5px;
}
.section-header .text-muted {
  font-size: 13px;
  color: #666;
}
.d-flex.gap-2 {
  gap: 10px;
}
.w-100 {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.services-table-container {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.services-table {
  width: 100%;
  border-collapse: collapse;
}
.services-table thead {
  background: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
}
.services-table th {
  padding: 15px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.services-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.services-table tbody tr:hover {
  background-color: #fafafa;
}
.services-table tbody tr:last-child {
  border-bottom: none;
}
.services-table td {
  padding: 15px;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
}
.concept-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
.concept-icon {
  color: #666;
  font-size: 20px;
}
.concept-name {
  font-weight: 500;
}
.booking-title {
  color: #555;
}
.duration-badge {
  display: inline-block;
  padding: 4px 12px;
  background: #f9ffe0;
  color: var(--cf-brand-dark);
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.price-text {
  font-weight: 600;
  color: #2e7d32;
}
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.status-badge.status-active {
  background: #e8f5e9;
  color: #2e7d32;
}
.status-badge.status-inactive {
  background: #ffebee;
  color: #c62828;
}
.staff-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #f5f5f5;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.small-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: #fafafa;
  text-align: center;
}
.empty-state mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #999;
  margin-bottom: 20px;
}
.empty-state h5 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.empty-state p {
  font-size: 14px;
  color: #666;
  margin-bottom: 25px;
  max-width: 400px;
}
.empty-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 1024px) {
  .services-table {
    font-size: 13px;
  }
  .services-table th,
  .services-table td {
    padding: 12px 10px;
  }
}
@media (max-width: 768px) {
  .service-section {
    padding: 15px;
  }
  .services-table-container {
    overflow-x: auto;
  }
  .services-table {
    min-width: 700px;
  }
  .empty-state {
    padding: 60px 15px;
  }
  .empty-actions {
    flex-direction: column;
    width: 100%;
  }
}
.drag-handle-col {
  width: 40px;
}
.drag-handle {
  cursor: grab;
  -webkit-user-select: none;
  user-select: none;
  color: #999;
}
.drag-handle:active {
  cursor: grabbing;
}
.drag-icon {
  font-size: 20px;
  vertical-align: middle;
}
.cdk-drag-preview {
  display: table;
  background: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
}
.cdk-drag-placeholder {
  opacity: 0.3;
}
.cdk-drag-animating {
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1);
}
.services-table tbody.cdk-drop-list-dragging .service-row:not(.cdk-drag-placeholder) {
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1);
}
/*# sourceMappingURL=location-service-section.component.css.map */
